import React from 'react';
import Meta from '../../../Components/Meta';
import ContactForm from '../../Workshop/ContactForm';
import Topics from '../../Workshop/Topics';
import Banner from './Banner';
import Collaboration from './Collaboration';
import Internships from './Internships';

const LogicProSummerInternships = () => {
  return (
    <div>
      <Meta
        title="Summer Program in association with Logic Pro, Lucknow"
        keywords="internships, summer program, LogicPro, alienbrains, summer, internship, lucknow"
      />
      <Banner />
      {/* <Collaboration /> */}
      <Internships />
      <br />
      <br />
      <ContactForm origin="lucknow_internship" isInternship={true} />
    </div>
  );
};

export default LogicProSummerInternships;



// WEBPACK FOOTER //
// ./src/Pages/SummerInternships/LogicPro/index.js